export default __webpack_public_path__ + "static/media/pawn_bishop_cyborg.52aeb252.png";